import { render } from "./TecnologiesStack.vue?vue&type=template&id=670aa960"
import script from "./TecnologiesStack.vue?vue&type=script&lang=js"
export * from "./TecnologiesStack.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__